
























import { Component, Vue } from 'vue-property-decorator';
import { ProjectService } from "@/services/project-service";
import { Project } from "@/models/project";
import {ProjectsParams} from "@/models/projects-params";
import TreeItem from "@/components/TreeItem.vue";

@Component({
    name: 'RootProjectsList',
    components: {
        TreeItem
    }
})
export default class RootProjectsList extends Vue {

    projectsList: Array<Project> = new Array<Project>();

    project_service: ProjectService = new ProjectService();
    project_params: ProjectsParams = new ProjectsParams();

    created() {
        this.getProjects();
    }

    getProjects() {
        this.project_params = new ProjectsParams();
        this.project_params.root = true;
        this.projectsList = new Array<Project>();
        this.project_service.getProjects(this.project_params)
            .then((response) => {
                this.projectsList = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
    }

}
